module.exports = __webpack_public_path__ + "static/media/witchCharacter.91ad7fc6.jpg";